import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './ProgressBarLikelty.module.scss';

const ProgressBarLikelty = ({ likely }) => {
  const numberForBar = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <div className={classes.chartWrap}>
      <Text className={classes.visually_hidden} type="p">
        {likely} from 10
      </Text>
      <div className={classes.diagramWrap}>
        <div
          style={{
            width:
              likely === 10
                ? '100%'
                : `calc((100% - 9px)/ 10 * ${likely} + 5px)`
          }}
          className={classes.itemChart}
        />
      </div>
      <div className={classes.numberWrap} aria-hidden="true">
        {numberForBar.map(numberBar => (
          <Text
            key={numberBar}
            className={numberBar > 0 ? classes.number : classes.numberZero}
          >
            {numberBar}
          </Text>
        ))}
      </div>
    </div>
  );
};

ProgressBarLikelty.propTypes = {
  likely: PropTypes.number
};

export default ProgressBarLikelty;
